// @flow
import React from "react";

import "./RadioGroup.css";

type Props = {
  className?: string,
  nome: string,
  itens: Array<any>,
  campoId: string,
  campoDescricao: string,
  onChange: (SyntheticInputEvent<>) => any,
  itemSelecionado?: number | string,
  disabled: boolean,
};

function RadioGroup({
  className = "RadioGroup",
  nome,
  itens,
  campoId,
  campoDescricao,
  itemSelecionado,
  onChange,
  disabled,
}: Props) {
  return (
    <>
      {itens.map(item => {
        return (
          <div
            className={`RadioGroup ${className}`}
            key={`radio${nome + item[campoId]}`}
            disabled={disabled}
          >
            <label className="RadioGroup__label">
              <input
                className="RadioGroup__input"
                type="radio"
                name={nome}
                value={item[campoId]}
                onChange={onChange}
                checked={itemSelecionado === item[campoId]}
                disabled={disabled}
              />
              <span className="RadioGroup__descricao" disabled={disabled}>
                {item[campoDescricao]}
              </span>
            </label>
          </div>
        );
      })}
    </>
  );
}

RadioGroup.defaultProps = {
  className: "RadioGroup",
  campoId: "id",
  campoDescricao: "chaveTraducao",
  disabled: false,
};

export default RadioGroup;
